import * as i0 from "@angular/core";
export class UtilsService {
    constructor() {
        this.pageTitle = '';
    }
    formatDate(date) {
        const day = date.getDate();
        const month = date.getMonth() + 1; // Add 1 because months are 0-indexed
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
    }
    findInvalidControls(form) {
        const invalid = [];
        const controls = form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }
    formatParamUri(param) {
        return (param.paramField != "") ? '&' + param.paramName + '=' + param.paramField : '';
    }
    isEmpty(obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }
    guid() {
        return this.s4() +
            this.s4() + '-' +
            this.s4() + '-' +
            this.s4() + '-' +
            this.s4() + '-' +
            this.s4() +
            this.s4() + this.s4();
    }
    s4() {
        return Math
            .floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    cloneArray(arr) {
        return JSON.parse(JSON.stringify(arr));
    }
    calculateAge(birthday) {
        var ageDifMs = Date.now() - birthday.getTime();
        var ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }
    pushItemToList(list, item) {
        list.push(item);
    }
    removeItemFromList(list, item) {
        for (var i = list.length - 1; i >= 0; i--) {
            if (list[i] == item) {
                list.splice(i, 1);
                break;
            }
        }
    }
    concatenateList(list, delimiter) {
        var returnVal = "";
        for (var i = 0; i < list.length; ++i) {
            returnVal += list[i] +
                ((i == list.length - 1) ? "" : delimiter);
        }
        return returnVal;
    }
    toggleItemFromListByAttr(list, attributeName, item) {
        var foundItem = this.returnItemFromListByAttr(list, attributeName, item[attributeName]);
        if (!this.isEmpty(foundItem)) {
            this.removeItemFromListByAttr(list, attributeName, item);
        }
        else {
            this.pushItemToList(list, item);
        }
    }
    removeItemFromListByAttr(list, attributeName, item) {
        for (var i = list.length - 1; i >= 0; i--) {
            if (list[i][attributeName] == item[attributeName]) {
                list.splice(i, 1);
                break;
            }
        }
    }
    concatenateListByAttr(list, attributeName, delimiter) {
        var returnVal = "";
        for (var i = 0; i < list.length; ++i) {
            returnVal += list[i][attributeName] +
                ((i == list.length - 1) ? "" : delimiter);
        }
        return returnVal;
    }
    returnItemFromListByAttr(list, attributeName, compareValue) {
        let returnVal = {};
        for (var i = 0; i < list.length; ++i) {
            if (list[i][attributeName] == compareValue) {
                returnVal = list[i];
                break;
            }
        }
        return returnVal;
    }
    updateItemFromListByAttr(list, attributeName, item) {
        list.forEach((element, index) => {
            if (element[attributeName] === item[attributeName]) {
                list[index] = item;
            }
        });
    }
    updateFormFromListByAttr(list, attributeName, item) {
        list.forEach((element, index) => {
            if (element[0].attributeName === item[0].attributeName) {
                list[index] = item;
            }
        });
    }
    returnListByAttr(list, attributeName, columnName) {
        var newList = [];
        for (var i = 0; i < list.length; ++i) {
            var obj = {};
            obj[columnName] = list[i][attributeName];
            newList.push(obj);
        }
        return newList;
    }
    verifyPdfExtension(fileName) {
        return new Promise((resolve, reject) => {
            if (fileName) {
                var extension = fileName.substring(fileName.indexOf(".") + 1);
                var isValid = false;
                switch (extension.toLowerCase()) {
                    case "pdf":
                        isValid = true;
                        break;
                    default:
                        isValid = false;
                }
                resolve(isValid);
                return isValid;
            }
            else {
                err => {
                    reject(err);
                };
                return false;
            }
        });
    }
    verifyFileExtension(fileName) {
        if (fileName) {
            var extension = fileName.substring(fileName.indexOf(".") + 1);
            var isValid = false;
            switch (extension.toLowerCase()) {
                case "jpeg":
                    isValid = true;
                    break;
                case "jpg":
                    isValid = true;
                    break;
                case "png":
                    isValid = true;
                    break;
                case "heic":
                    isValid = true;
                    break;
                case "pdf":
                    isValid = true;
                    break;
                default:
                    isValid = false;
            }
            return isValid;
        }
        else {
            return false;
        }
    }
    verifyImageExtension(fileName) {
        if (fileName) {
            var extension = fileName.split('.').pop();
            var isImage = false;
            switch (extension.toLowerCase()) {
                case "jpeg":
                    isImage = true;
                    break;
                case "jpg":
                    isImage = true;
                    break;
                case "png":
                    isImage = true;
                    break;
                /* 	    case "bmp":
                            isImage = true
                            break;
                        case "gif":
                            isImage = true
                            break;
                        default:
                            isImage = false */
            }
            return isImage;
        }
        else {
            return false;
        }
    }
    // Método para generar ID aleatorio usando el servicio existente
    generateRandomId() {
        return this.guid();
    }
    // Método para generar ID numérico simple
    generateNumericId() {
        return Math.floor(Math.random() * 1000000);
    }
    // Método para generar ID con timestamp
    generateTimestampId() {
        return Date.now() + Math.floor(Math.random() * 1000);
    }
    // Método para generar ID alfanumérico
    generateAlphanumericId(length = 8) {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    }
}
UtilsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UtilsService_Factory() { return new UtilsService(); }, token: UtilsService, providedIn: "root" });
